import { render, staticRenderFns } from "./AddEditRole.vue?vue&type=template&id=3833a3fd&scoped=true"
import script from "./AddEditRole.vue?vue&type=script&lang=js"
export * from "./AddEditRole.vue?vue&type=script&lang=js"
import style0 from "./AddEditRole.vue?vue&type=style&index=0&id=3833a3fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3833a3fd",
  null
  
)

export default component.exports